function removeFormField (select: HTMLSelectElement): void {
    const container = select.parentElement as HTMLElement;
    container.previousElementSibling?.remove();
    container.remove();
}

function init (): void {
    const institutions = document.querySelector('#institutions') as HTMLSelectElement;
    const studies = document.querySelector('#studies') as HTMLSelectElement;

    document.querySelector('#locations')?.addEventListener('change', () => {
        if (institutions) {
            removeFormField(institutions);
        }
        if (studies) {
            removeFormField(studies);
        }
    });

    if (institutions) {
        institutions.addEventListener('change', () => {
            if (studies) {
                removeFormField(studies);
            }
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
} else {
    init();
}

export {};
